import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.css']
})
export class DeleteButtonComponent {
  canDelete: boolean;

  @Output() delete = new EventEmitter<boolean>();

  cancel(): void {
    this.canDelete = false;
  }

  prepareForDelete(): void {
    this.canDelete = true;
  }

  deleteItem(): void {
    this.delete.emit(true);
    this.canDelete = false;
  }
}
